import api from './api'

export const tagService = {
  // 获取所有标签
  getAllTags() {
    return api.get('/tags')
  },

  // 获取标签详情
  getTag(id) {
    return api.get(`/tags/${id}`)
  },

  // 创建标签
  createTag(tagData) {
    return api.post('/tags', tagData)
  },

  // 更新标签
  updateTag(id, tagData) {
    return api.put(`/tags/${id}`, tagData)
  },

  // 删除标签
  deleteTag(id) {
    return api.delete(`/tags/${id}`)
  }
}

